import {
  TTS_ANALYTICS_AD_PERFORMANCE_PATH,
  TTS_ANALYTICS_COLLABORATION_PERFORMANCE_PATH,
  TTS_ANALYTICS_OUTREACH_PERFORMANCE_PATH,
  TTS_ANALYTICS_PERFORMANCE_DASHBOARD_PATH,
  TTS_ANALYTICS_PERFORMANCE_OVERVIEW_PATH,
  TTS_ANALYTICS_PRODUCT_PERFORMANCE_PATH,
  TTS_ANALYTICS_SAMPLES_BY_TIER_DASHBOARD_PATH,
  TTS_ANALYTICS_TOP_CREATORS_PATH,
  TTS_ANALYTICS_VIDEO_PERFORMANCE_PATH
} from 'constants/routeConstants';

import type { MetricTabEntry } from 'model/types/data-analytics';

export const METRIC_TABS: MetricTabEntry[] = [
  { labelId: 'data-analytics-tab-performance-overview', path: TTS_ANALYTICS_PERFORMANCE_OVERVIEW_PATH },
  { labelId: 'data-analytics-tab-performance-dashboard', path: TTS_ANALYTICS_PERFORMANCE_DASHBOARD_PATH },
  { labelId: 'data-analytics-tab-outreach-performance', path: TTS_ANALYTICS_OUTREACH_PERFORMANCE_PATH },
  { labelId: 'data-analytics-tab-ad-performance', path: TTS_ANALYTICS_AD_PERFORMANCE_PATH },
  { labelId: 'data-analytics-tab-product-performance', path: TTS_ANALYTICS_PRODUCT_PERFORMANCE_PATH },
  { labelId: 'data-analytics-tab-collaboration-performance', path: TTS_ANALYTICS_COLLABORATION_PERFORMANCE_PATH },
  { labelId: 'data-analytics-tab-video-performance', path: TTS_ANALYTICS_VIDEO_PERFORMANCE_PATH },
  {
    labelId: 'data-analytics-tab-samples-by-tier-dashboard',
    path: TTS_ANALYTICS_SAMPLES_BY_TIER_DASHBOARD_PATH
  },
  { labelId: 'data-analytics-tab-top-creators', path: TTS_ANALYTICS_TOP_CREATORS_PATH }
];
